module.exports = __webpack_public_path__ + "img/effie-awards-logo.ccc42582.svg";